import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RouteStopItem } from '../../schedule.model';
import { SchedulePartialStoreState } from '../schedule.reducer';
import { RouteStopsActions } from './route-stops.actions';
import * as RouteStopSelector from './route-stops.selectors';

@Injectable()
export class RouteStopsFacade {
    routeStops$: Observable<RouteStopItem[]> = this.store.select(RouteStopSelector.getRouteStops);
    loading$: Observable<boolean> = this.store.select(RouteStopSelector.getLoading);
    ids$: Observable<number[]> = this.store.select(RouteStopSelector.getStopsIds);
    selectedId$: Observable<number> = this.store.select(RouteStopSelector.getSelectedId);
    routePolyline$: Observable<any> = this.store.select(RouteStopSelector.getRoutePolyline);

    scheduleDays$: Observable<any> = this.store.select(RouteStopSelector.getScheduleDays);
    departures$: Observable<any> = this.store.select(RouteStopSelector.getDepartures);

    selectedDay$: Observable<string> = this.store.select(RouteStopSelector.getSelectedDay);

    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: RouteStopsActions) {}

    fetchRouteStops(routeId: number, directionId: string) {
        this.store.dispatch(this.actions.fetchRouteStops({ routeId, directionId }));
    }

    fetchRoutePolyline(routeId: number, directionId: string) {
        this.store.dispatch(this.actions.fetchRoutePolyline({ routeId, directionId }));
    }

    resetRouteStops() {
        this.store.dispatch(this.actions.resetRouteStops());
    }

    fetchStopDepartures(routeId: number, stopId: number) {
        this.store.dispatch(this.actions.fetchRouteStopDepartures({ routeId, stopId }));
    }

    setSelectedStop(stopId: number) {
        this.store.dispatch(this.actions.setSelectedStop(stopId));
    }

    setSelectedDay(day: string) {
        this.store.dispatch(this.actions.setSelectedDay(day));
    }
}
